import { typedEntries, typedFromEntries } from "~/utils";

export type LobbyGameParams = {
  useBaseGame: boolean;
  useIxExtension: boolean;
};

export const LobbyGameParams = {
  toRecord(params: LobbyGameParams): Record<string, string> {
    return typedFromEntries(
      typedEntries(params).map(([key, value]) => [key, value.toString()])
    );
  },
  fromRecord(record: Record<string, string>): LobbyGameParams {
    return {
      useIxExtension: record["useIxExtension"] === "true",
      useBaseGame: record["useBaseGame"] === "true",
    };
  },
};
